











import { Vue, Component } from "vue-property-decorator";
import MiniClose from "../../../assets/svg/mini-close.svg"

@Component({ components: {MiniClose} })
export default class Pocket extends Vue {

    get showClose() {
        return Boolean(this.$listeners.close);
    }

}
